import React from "react";
import "components/Content/Toolbar/CSS Files/tooglebar.css"
import "components/Content/Toolbar/CSS Files/Toolbar.css"
import {LoadStockImages} from "components/Content/Toolbar/Data_Retrieval/loadStockImages"


class Images extends React.Component {


    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                <LoadStockImages/>
            </div>
        );

    }
}

export default Images;